<button type="button" class="btn tertiary link" [disabled]="disabled" (click)="stepper.previous()">
  <i class="vitamui-icon vitamui-icon-chevron-left"></i>
  {{ 'COMMON.BACK' | translate }}
</button>
